import PropTypes from 'prop-types';
import React from 'react';
import ButtonLink from '../ButtonLink';
import Rating from '../Rating';
import css from './ShopToolbar.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ShopToolbar = function ShopToolbar(_ref) {
  var price = _ref.price,
      rating = _ref.rating,
      title = _ref.title,
      url = _ref.url;
  return /*#__PURE__*/_jsxs("footer", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.left,
      children: [/*#__PURE__*/_jsx("p", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: css.rating,
        children: /*#__PURE__*/_jsx(Rating, {
          light: true,
          size: 12,
          value: rating
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.right,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.price,
        children: "$".concat(price)
      }), /*#__PURE__*/_jsx(ButtonLink, {
        borderedHover: true,
        big: true,
        href: url,
        children: "Shop ".concat(title)
      })]
    })]
  });
};

ShopToolbar.propTypes = {
  price: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};
export default ShopToolbar;